import React, { useState, useEffect } from "react";
import styles from "./ImageSelector.module.css";
import PropTypes from "prop-types";
import {
  PatternlibImage,
  PatternlibSelectionCardGroup,
  PatternlibSelectionCard,
} from "@liebherr/patternlib-react";
import useMutationObserver from "../../hooks/useMutationObserver";

const ImageSelector = ({ data, variable, project, onChange, disabled }) => {
  const [value, setValue] = useState({});

  // use mutation observer to get current screen size
  const options = {
    config: { attributes: true, childList: true, subtree: true },
  };
  const target = document.documentElement;
  const attributeName = "breakpoint";
  const screen = useMutationObserver(options, target, attributeName);

  useEffect(() => {
    if (Object.keys(value).length >= 1) {
      // Find the current selected
      const currentSelected = data.values.find(
        (item) => data["resolvedVal"] === item.name
      );
      // Ignore output from lhSelect if value is equal to currentSelected
      if (value.value !== currentSelected.value) {
        onChange(value);
      }
    }
  }, [value]);

  const onSelectListener = (event) => {
    const selectedValue = event.detail;
    setValue({ variable, value: selectedValue });
  };

  const getCurrentSelected = () => {
    const item = data.values.find((item) => data["resolvedVal"] === item.name);
    return item.value;
  };

  return (
    <div key={variable} className={styles.cardContainer}>
      <span className={styles.headline}>{data["desc"]}</span>
      <div className={styles.cardWrapper}>
        <PatternlibSelectionCardGroup
          grid-wrap
          horizontal
          items-min-width="144px"
          key={variable}
          onLhCardSelection={(e) => onSelectListener(e)}
          value={getCurrentSelected()}
        >
          {data.values.map(function (item, index) {
            const imagePath = item.image;
            const imageName =
              project !== ""
                ? imagePath.replace(`liebherr_components/${project}/`, "")
                : imagePath.replace(`liebherr_components`, "");
            return (
              <PatternlibSelectionCard
                checked={data["resolvedVal"] === item.name}
                key={variable + "-" + index}
                value={item.value}
                disabled={false}
              >
                <div className={styles.card}>
                  <PatternlibImage
                    src={
                      `https://webapi.partcommunity.com/FileService/CatalogImage?PreviewPath=liebherr_components/${project}/` +
                      imageName
                    }
                  ></PatternlibImage>
                  <span className={styles.cardItemName}>{item.name}</span>
                </div>
              </PatternlibSelectionCard>
            );
          })}
        </PatternlibSelectionCardGroup>
      </div>
    </div>
  );
};

ImageSelector.propTypes = {
  label: PropTypes.string,
  data: PropTypes.any,
  variable: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ImageSelector.defaultProps = {
  variable: "",
  project: "",
  disabled: false,
};

export default ImageSelector;
